// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,ScoreCard
}                         from '../../../components';

class PartnerSummer extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerCricket');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded, fetchScoreCardDataIfNeeded
      }
    } = this.props;

  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerCricket');
  }

  render() {
    const {
      statsTable, scoreCard
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded
      }
    } = this.props;

    return(
      <div>    
        <div className="row">
          <ScoreCard name="summercamp_score_card" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div>
        <div className="lead_flow">
          <div className="lead_header">
          <h4>Football SummerCamp</h4>
          </div>
         <div className="row hot_leads_pipeline">
         <div className="col-md-3">
          <StatsTable bigTable={true} name="response" game_type_id={16} displayName="Response" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="contact_later" game_type_id={16} displayName="Contact Later" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="demo" game_type_id={16} displayName="Demos" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="verbal_confirmation" game_type_id={16} displayName="Verbal Confirmation" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          </div>
         </div> 
        <div className="row">
          <StatsTable name="summercamp_lead_summary" displayName="Leads Summary" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>


        <div className="row">
          <StatsTable bigTable={true} name="batch_health" game_type_id={16} displayName="Batch Health" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
         <div className="row">
          <StatsTable bigTable={true} name="all_leads" game_type_id={16} data={statsTable} displayName="All Leads" reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} name="active_customers" game_type_id={16} displayName="Active Customers" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>  

       
      </div>
    );
  }
}

export default PartnerSummer;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerSummer/PartnerSummer.js